var path = 'areas/shared/views/interrupt-fields/interrupt_SubmitButtonGroup.html';
var html = "<div class=submit-button-group> <button class=\"btn btn-default\" ng-repeat=\"bt in element.properties.Buttons\" ng-click=\"submit(element, bt.Value)\" ng-disabled=isDisabled>{{ bt.Text }}</button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/interrupt-fields/interrupt_SubmitButtonGroup.html
// module id = 966
// module chunks = 1